import jwt from 'jsonwebtoken'
import * as Sentry from '@sentry/browser'

const keyBase = 'trafiki'
const tokenKey = `${keyBase}:token`
let cache

const setToken = (token) => {
    Sentry.configureScope((scope) => {
        const { sub, email } = jwt.decode(token.id_token)
        const [, id] = sub.split('|')
        scope.setUser({
            id,
            email,
        })
    })
    cache = token
    localStorage.setItem(tokenKey, JSON.stringify(token))
}

const getToken = () => {
    if (cache == null) {
        cache = JSON.parse(localStorage.getItem(tokenKey))
    }

    return cache
}

const get = () => {
    const authToken = getToken()
    if (authToken == null) {
        return ''
    }
    const { token_type: type, id_token: token } = authToken
    return `${type} ${token}`
}

const clear = () => {
    cache = null
    localStorage.removeItem(tokenKey)
}

export const auth = {
    setToken,
    getToken,
    get,
    clear,
}
